"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserTeamNotificationParamsSchema = exports.UserNotificationParamsSchema = exports.ListNotificationMessagesQuerySchema = exports.ListTeamRecipientsQuerySchema = exports.ListUserRecipientsQuerySchema = exports.UserNotificationIdParamsSchema = exports.UpdateTeamNotificationSettingsBodySchema = exports.UpdateUserNotificationSettingsBodySchema = exports.NotificationSettingsBodySchema = exports.DeleteNotificationMessagesBodySchema = exports.UpdateTeamNotificationSettingsResponseSchema = exports.GetTeamNotificationSettingsResponseSchema = exports.UpdateUserNotificationSettingsResponseSchema = exports.GetUserNotificationSettingsResponseSchema = exports.NotificationSettingsResponseSchema = exports.ListNotificationMessagesResponseSchema = exports.GetNotificationMessageResponseSchema = exports.NotificationMessageResponseSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
const common_1 = require("../common");
/**
 * Responses
 */
exports.NotificationMessageResponseSchema = (0, core_1.StrictObject)(common_1.NotificationMessageFields);
exports.GetNotificationMessageResponseSchema = exports.NotificationMessageResponseSchema;
exports.ListNotificationMessagesResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.NotificationMessageResponseSchema);
exports.NotificationSettingsResponseSchema = (0, core_1.StrictObject)(common_1.NotificationSettingsFields);
exports.GetUserNotificationSettingsResponseSchema = exports.NotificationSettingsResponseSchema;
exports.UpdateUserNotificationSettingsResponseSchema = exports.NotificationSettingsResponseSchema;
exports.GetTeamNotificationSettingsResponseSchema = exports.NotificationSettingsResponseSchema;
exports.UpdateTeamNotificationSettingsResponseSchema = exports.NotificationSettingsResponseSchema;
/**
 * Body
 */
exports.DeleteNotificationMessagesBodySchema = (0, core_1.StrictObject)({
    ...core_1.DateFilterFields,
});
exports.NotificationSettingsBodySchema = (0, core_1.StrictObject)({
    email: typebox_1.Type.Array(ruby_1.NotificationTypeSchema),
    web: typebox_1.Type.Array(ruby_1.NotificationTypeSchema),
});
exports.UpdateUserNotificationSettingsBodySchema = exports.NotificationSettingsBodySchema;
exports.UpdateTeamNotificationSettingsBodySchema = exports.NotificationSettingsBodySchema;
/**
 * Parameters
 */
exports.UserNotificationIdParamsSchema = (0, core_1.StrictObject)({
    userId: core_1.IdSchema,
    notificationId: core_1.IdSchema,
});
exports.ListUserRecipientsQuerySchema = (0, core_1.StrictObject)({
    type: ruby_1.NotificationTypeSchema,
});
exports.ListTeamRecipientsQuerySchema = (0, core_1.StrictObject)({
    type: ruby_1.NotificationTypeSchema,
    campaignId: typebox_1.Type.Optional(core_1.IdSchema),
});
exports.ListNotificationMessagesQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({
    ...core_1.DateFilterFields,
    type: typebox_1.Type.Optional(typebox_1.Type.Array(ruby_1.NotificationTypeSchema)),
});
exports.UserNotificationParamsSchema = (0, core_1.StrictObject)({
    userId: core_1.IdSchema,
});
exports.UserTeamNotificationParamsSchema = (0, core_1.StrictObject)({
    userId: core_1.IdSchema,
    teamId: core_1.IdSchema,
});
